import { getDataClient } from "@/lib/dataClient";
import { useDataQuery } from "@/hooks/useDataQuery";

export interface ParentContact {
  userId: string;
  name: string;
  phone: string;
}

/** Yönetici: telefonu kayıtlı velileri listeler (SMS bildirimi için). */
export function useParentsWithPhone() {
  return useDataQuery<ParentContact[]>(async () => {
    const dataClient = getDataClient();
    const { data, error } = await dataClient
      .from("profiles")
      .select("user_id, full_name, phone")
      .eq("role", "veli")
      .order("full_name", { ascending: true });
    if (error) throw error;
    return (data ?? [])
      .map((p: { user_id: string | null; full_name: string | null; phone: string | null }) => ({
        userId: p.user_id ?? "",
        name: p.full_name ?? "Veli",
        phone: p.phone ?? "",
      }))
      .filter((p) => p.phone);
  });
}

export interface SmsResult {
  ok: boolean;
  configured: boolean;
  error?: string;
}

/** Netgsm üzerinden SMS gönderir (Edge Function aracılığıyla). */
export async function sendSms(phone: string, message: string): Promise<SmsResult> {
  const dataClient = getDataClient();
  const { data, error } = await dataClient.functions.invoke("send-sms", {
    body: { phone, message },
  });
  if (error) {
    return { ok: false, configured: false, error: error.message };
  }
  const d = (data ?? {}) as { ok?: boolean; configured?: boolean; error?: string };
  return {
    ok: Boolean(d.ok),
    configured: d.configured !== false,
    error: d.error,
  };
}